import axios from "axios";
import { urlParams, dateFormat, isDevMode } from "@/utils";
import config from "@/config";

let url = `https://bookings.willowlife.co.uk/bookings-api/v1`;

class ApiService {
    constructor(ax) {
        this.http = ax;

        //  Add an axios interceptor to turn date objects into date strings... without changing time zones
        this.http.interceptors.request.use(function (config) {
            try {
                if (!config.data) return config;
                for (var key in config.data) {
                    const value = config.data[key];
                    if (value instanceof Date) config.data[key] = dateFormat(value, "YYYY-MM-DD HH:mm:ss");
                }
                return config;
            }
            catch (e) { return config; }
        });
    }

    //  Used for simple web log GET requests
    webLogGet(url) {
        return this.http({
            url,
            baseURL: `https://bookings.willowlife.co.uk`,
            params: urlParams()
        });
    }

    get(uri, params) { return this.http.get(uri, { params: params }); }
    post(uri, params) { return this.http.post(uri, params); }
    put(uri, params) { return this.http.put(uri, params); }
    delete(uri, params) { return this.http.delete(uri, params); }

    headers() { return this.http.defaults.headers; }

    setHeader(headerName, headerValue) {
        this.http.defaults.headers.common[headerName] = headerValue;
        return this;
    }
    deleteHeader(headerName) {
        this.http.defaults.headers.common[headerName] = null;
        return this;
    }
}

const headers = {
    "X-Api-Key": config.willowApiKey
};

if(isDevMode) {
    headers["X-Dev-Mode"] = 1;
}

const willowApi = new ApiService(axios.create({ baseURL: url, headers }));

export default willowApi;
